import ActionCableVue from "actioncable-vue";
import Vue from "vue";
import AppConfig from "~/appConfig";
import BaseCan from "../../common/abilities/baseCan";
import Organization from "../../common/models/organization";
import User from "../../common/models/user";
import Selected from "../../common/state/modules/selected";
import store from "../../common/state/store";
import "../../common/vue/common";
import App from './app_vue.vue';
import StoreFactory from "./store/storeFactory";


// in develop and onestop, use formability's websocket connection instead of onestop's
// in other environments, this should be handled by nginx
let connectionHost = (<any>window).API_HOST
if (!connectionHost) {
  let port = window.location.port;
  if (import.meta.env.DEV) {
    port = !!(<any>window).ONE_STOP ? "3000" : window.location.port;
  }
  connectionHost = `${window.location.hostname}${port !== "" ? ':' + port : ''}`
}

Vue.use(ActionCableVue, {
  debug: true,
  debugLevel: 'error',
  connectionUrl: `${window.location.protocol === 'http:' ? 'ws' : 'wss'}://${connectionHost}/cable`,
  connectImmediately: false,
});

const onReady = function () {
  window.AppConfig = new AppConfig();
  Selected.register(Selected);

  const $rootElement = $(document).find('#vue-application');
  if ($rootElement.length === 0) {
    return;
  }

  const user = User.repo.findOrCreate($rootElement.data('user')?.id).loadFromJson($rootElement.data('user'));
  Selected.currentUser.set(user);
  Vue.use(new BaseCan(user));
  let orgJson = $rootElement.data('organization');
  const organization = (orgJson ? Organization.repo.findOrCreate(orgJson.id) : new Organization()).loadFromJson(orgJson);
  Selected.organization.set(organization);

  const breadcrumbs = $rootElement.data('breadcrumbs');
  const flash = $rootElement.data('flash');
  StoreFactory.registerModules(flash, organization.time_zone);
  const app = new Vue({
    el: "#vue-application",
    render: function (createElement) {
      return createElement(
        App, {
          props: {
            user: user,
            html: $(this.$el).html(),
            breadcrumbs: breadcrumbs,
          }
        }
      )
    },
    store,
  });
};

$(onReady);
